/**
 * @generated SignedSource<<151799548bb8958ee87098291875591d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorListFragment_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"InstructorCardFragment_session">;
  readonly " $fragmentType": "InstructorListFragment_session";
};
export type InstructorListFragment_session$key = {
  readonly " $data"?: InstructorListFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorListFragment_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InstructorListFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InstructorCardFragment_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "78880c3d09833c95d728363286d92d1f";

export default node;
